import { useState } from 'react';
import {
  Typography,
  Box,
  Grid,
  AppBar,
  Tab,
  Tabs,
} from '@mui/material';

interface tabType {
  name?: React.ReactNode;
  disabled?: boolean;
  className?: string;
}

interface tabContentType {
  content: React.ReactNode;
}

interface Props {
  tabs: tabType[];
  tabContent: tabContentType[];
  className?: string;
  onChange?: (event: React.SyntheticEvent, newValue: number) => void;
}

interface TabPanelProps {
  children?: React.ReactNode;
  dir?: string;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;
  return (
    <Typography
      component="div"
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      <Box p={3}>{children}</Box>
    </Typography>
  );
}

function a11yProps(index: number) {
  return {
    id: `full-width-tab-${index}`,
    'aria-controls': `full-width-tabpanel-${index}`,
  };
}

const GenericTabs: React.FC<Props> = (props) => {
  const [value, setValue] = useState(0);

  const handleChange = (_event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
    if (props.onChange) {
      props.onChange(_event, newValue);
    }
  };

  return (
    <Grid
      sx={{
        backgroundColor: 'background.paper',
        width: '100%',
      }}
    >
      <AppBar position="static" color="default" sx={{ boxShadow: 'none' }}>
        <Tabs
          value={value}
          className={props.className ? props.className : ''}
          onChange={handleChange}
          TabIndicatorProps={{
            style: {
              backgroundColor: '#0268B2',
            },
          }}
          variant="fullWidth"
          aria-label="tabs"
        >
          {props.tabs.map((tab: tabType, index: number) => {
            if (tab.disabled) {
              return (
                <Tab
                  key={index}
                  className={tab.className}
                  label={tab.name}
                  disabled
                  {...a11yProps(index)}
                />
              );
            }
            return (
              <Tab
                key={index}
                className={tab.className}
                label={tab.name}
                {...a11yProps(index)}
              />
            );
          })}
        </Tabs>
      </AppBar>
      {props.tabContent.map((tabContent: tabContentType, index: number) => {
        return (
          <TabPanel value={value} index={index} key={index}>
            {tabContent.content}
          </TabPanel>
        );
      })}
    </Grid>
  );
};

export default GenericTabs;
